import {
	TwoFactorAuthPayload,
	validateTwoFactorAuthenticationCode,
} from "@/api/register";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

type Validate2FACodeParams = {
	payload: TwoFactorAuthPayload;
	locationId: number;
};

export default function useValidateTwoFactorAuthenticationCode(
	options?: MutationOptionsWithoutFn<unknown, Validate2FACodeParams>,
) {
	return useMutation({
		...options,
		mutationFn: async ({ payload, locationId }: Validate2FACodeParams) => {
			const response = await validateTwoFactorAuthenticationCode(
				payload,
				locationId,
			);
			return response;
		},
	});
}
